import React from 'react';
import AceEditor from 'react-ace';
import { useTheme } from '../App';

// Import existing modes
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-typescript';
import 'ace-builds/src-noconflict/mode-csharp';
import 'ace-builds/src-noconflict/mode-java';
import 'ace-builds/src-noconflict/mode-golang';
import 'ace-builds/src-noconflict/mode-php';
import 'ace-builds/src-noconflict/mode-ruby';
import 'ace-builds/src-noconflict/mode-swift';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/mode-c_cpp';
import 'ace-builds/src-noconflict/mode-kotlin';
import 'ace-builds/src-noconflict/mode-lua';
import 'ace-builds/src-noconflict/mode-rust';
import 'ace-builds/src-noconflict/mode-dart';
import 'ace-builds/src-noconflict/mode-sh';
import 'ace-builds/src-noconflict/mode-powershell';

// Import themes
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/theme-xcode';
import 'ace-builds/src-noconflict/theme-solarized_light';
import 'ace-builds/src-noconflict/theme-textmate';

const RequestCodeDisplay = ({ language, codeSnippet, expanded }) => {
  const { theme, currentTheme } = useTheme();
  
  const languageMode = (() => {
    switch (language) {
      case 'Node':
        return 'javascript';
      case 'TypeScript':
        return 'typescript';
      case 'Python':
        return 'python';
      case 'Unreal C++':
        return 'c_cpp'; 
      case 'C#':
        return 'csharp';
      case 'Unity C#':
        return 'csharp'; 
      case 'C++':
        return 'c_cpp';
      case 'Java':
        return 'java';
      case 'Kotlin':
        return 'kotlin';
      case 'Go':
        return 'golang';
      case 'PHP':
        return 'php';
      case 'Ruby':
        return 'ruby';
      case 'Swift':
        return 'swift';
      case 'Lua':
        return 'lua';
      case 'GDScript':
        return 'python'; // GDScript is Python-like, so we use Python mode
      case 'Rust':
        return 'rust';
      case 'Dart':
        return 'dart';
      case 'Shell':
        return 'sh';
      case 'PowerShell':
        return 'powershell';
      case 'cURL':
        return 'sh'; // cURL commands use shell syntax
      default:
        return 'text';
    }
  })();

  // Use themes that have better light backgrounds
  const editorTheme = currentTheme === 'dark' ? 'monokai' : 'github';

  return (
    <div style={{ 
      borderRadius: '6px',
      overflow: 'hidden',
      border: `1px solid ${theme.border}`,
      boxShadow: currentTheme === 'dark' ? '0 2px 6px rgba(0, 0, 0, 0.3)' : '0 2px 6px rgba(0, 0, 0, 0.1)'
    }}>
      <AceEditor
        mode={languageMode}
        theme={editorTheme}
        value={codeSnippet}
        readOnly={true}
        height={expanded ? '560px' : '280px'} 
        width="100%"
        setOptions={{ 
          useWorker: false, 
          wrap: true, 
          printMargin: false,
          showGutter: true,
          highlightActiveLine: false,
          showPrintMargin: false,
          fontSize: 14,
        }}
        style={{ 
          fontFamily: "'Fira Code', 'Source Code Pro', monospace",
        }}
        editorProps={{ $blockScrolling: true }}
      />
    </div>
  );
};

export default RequestCodeDisplay;